import React from 'react';
import { Page, Text, Image, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing, layout } from './styles/theme';
import Logo from '../../img/EventoVirtual_LogoHorizontal.png';

const styles = StyleSheet.create({
  page: {
    paddingTop: layout.headerHeight + spacing.md,
    paddingBottom: layout.footerHeight + spacing.sm,
    paddingHorizontal: layout.margin.left,
    backgroundColor: colors.background.white,
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: layout.headerHeight,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.lg,
    borderBottomWidth: 2,
    borderBottomColor: colors.primary,
    borderBottomStyle: 'solid',
    backgroundColor: colors.background.white,
  },
  logo: {
    height: 28,
    width: 'auto',
  },
  body: {
    flex: 1,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: layout.footerHeight,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.lg,
    borderTopWidth: 1,
    borderTopColor: colors.border.light,
    borderTopStyle: 'solid',
    backgroundColor: colors.background.white,
  },
  footerText: {
    ...typography.footer,
    flex: 1,
    lineHeight: 1.4,
  },
  pageNumber: {
    fontSize: 10,
    color: colors.text.muted,
    fontWeight: 'bold',
  },
});

const EVPage = ({
  date = '',
  user = 'Usuario',
  email = '',
  children = null,
  noWrap = false,
}) => {
  return (
    <Page size="LETTER" wrap={noWrap} style={styles.page}>
      {/* Header */}
      <View style={styles.header} fixed>
        <Image style={styles.logo} src={Logo} />
      </View>

      {/* Body Content */}
      <View style={styles.body} wrap={noWrap}>
        {children}
      </View>

      {/* Footer */}
      <View style={styles.footer} fixed>
        <Text style={styles.footerText}>
          {date && `Generado: ${date}`}
          {'\n'}
          {user && `Solicitado por: ${user}`}
          {email && ` (${email})`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
      </View>
    </Page>
  );
};

export default EVPage;
